import React, { Component } from "react";
import { Row, Col, Input, Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { debounce } from 'lodash'
import axios from 'axios'
import { CUSTOMER_BUYER_URL } from "../../actions/url";

class BuyerAddModal extends Component {
    constructor() {
        super();
        this.state = {
            FirstName: '',
            Cellphone: '',
            Street: '',
            City: '',
            State: '',
            Zip: '',
            Fax: '',
            customerName: '',
            customer_id: '',
        }
    }

    componentDidMount() {
        if (this.props.customer) {
            this.setState({
                customerName: this.props.customer.Name,
                customer_id: this.props.customer.Customer_id,
            })
        }
    }

    componentWillUnmount() {
        this.setState({
            FirstName: '',
            Cellphone: '',
            Street: '',
            City: '',
            State: '',
            Zip: '',
            Fax: '',
            customerName: '',
            customer_id: '',
        })
    }

    handleDebounceAddBuyer = debounce(() => {
        const {Street, City, State, Zip, Cellphone, FirstName, Fax, customer_id} = this.state;
        const {close, refreshBuyerList} = this.props;
        if (!FirstName) {
            alert('FirstName required fields');
            return;
        }
        let data = {
            Street,
            City,
            State,
            Zip,
            Cellphone,
            FirstName,
            Fax,
            customer:customer_id,
        }
        axios({
            method: 'POST',
            data,
            url: CUSTOMER_BUYER_URL,
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        })
            .then(res => {
                alert('Add Success');
                close();
                refreshBuyerList();
            }, err => {
                const data = err.data;
                alert(JSON.stringify(data));
            })
    }, 200);

    render() {
        const { FirstName, Street, State, Fax, Cellphone, City, Zip, customerName } = this.state;
        return <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>
            <Row>
                <Col sm={6}>
                    <Col>
                        <label><Translate value="name" /></label>
                        <Input
                            type='text'
                            value={FirstName}
                            onChange={(e) => {
                                this.setState({
                                    FirstName: e.target.value,
                                })
                            }} />
                    </Col>
                    <Col>
                        <label><Translate value="street" /></label>
                        <Input
                            type='text'
                            value={Street}
                            onChange={(e) => {
                                this.setState({
                                    Street: e.target.value,
                                })
                            }} />
                    </Col>
                    <Col>
                        <label><Translate value="state" /></label>
                        <Input
                            type='text'
                            value={State}
                            onChange={(e) => {
                                this.setState({
                                    State: e.target.value,
                                })
                            }} />
                    </Col>
                    <Col>
                        <label><Translate value="fax" /></label>
                        <Input
                            type='text'
                            value={Fax}
                            onChange={(e) => {
                                this.setState({
                                    Fax: e.target.value,
                                })
                            }} />
                    </Col>
                </Col>
                <Col sm={6}>
                    <Col>
                        <label><Translate value="cell_phone" /></label>
                        <Input
                            type='text'
                            value={Cellphone}
                            onChange={(e) => {
                                this.setState({
                                    Cellphone: e.target.value,
                                })
                            }} />
                    </Col>
                    <Col>
                        <label><Translate value="city" /></label>
                        <Input
                            type='text'
                            value={City}
                            onChange={(e) => {
                                this.setState({
                                    City: e.target.value,
                                })
                            }} />
                    </Col>
                    <Col>
                        <label><Translate value="zip" /></label>
                        <Input
                            type='text'
                            value={Zip}
                            onChange={(e) => {
                                this.setState({
                                    Zip: e.target.value,
                                })
                            }} />
                    </Col>
                    <Col>
                        <label><Translate value="customer" /></label>
                        <Input
                            type='text'
                            disabled
                            value={customerName}
                        />
                    </Col>
                </Col>
            </Row>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '50px' }}>
                <Button
                    className="btn btn-success"
                    onClick={this.handleDebounceAddBuyer}>
                    <Translate value="submit" />
                </Button>
            </div>
        </div>
    }
}

export default BuyerAddModal;


// WEBPACK FOOTER //
// ./master/jsx/components/Customers/BuyerAddModal.jsx